/**
 * Models the chart reviews bulk edit screen
 */

import Brace from "backbone.brace";
import BulkAssignments from "../../collections/chart-reviews/bulk-assigments";
import { numberFormatter } from "../../utils";

const BulkAssignForm = Brace.Model.extend({
  namedAttributes: {
    limitedTo: Number,
    reviewers: [Number],
    assignments: BulkAssignments,
    assignmentCount: Number,
    keepExistingReviewers: Boolean,
  },

  defaults: {
    limitedTo: null,
    reviewers: null,
    assignments: new BulkAssignments(),
    assignmentCount: null,
    keepExistingReviewers: null,
  },

  _calculations() {
    // reduce assignment counts
    let assignmentCount = 0;
    if (this.getAssignments()) {
      assignmentCount = this.getAssignments().reduce(
        (memo, model) => memo + model.getCount(),
        0
      );
    }

    this.set({
      assignmentCount,
    });
  },

  allAssigned() {
    return Number(this.getAssignmentCount()) === Number(this.getLimitedTo());
  },

  validate(attrs) {
    this._calculations();

    if (Array.isArray(attrs.reviewers) && attrs.reviewers.length) {
      // set keepExistingReviewers flag to false when not checked
      if (!attrs.keepExistingReviewers) {
        this.setKeepExistingReviewers(false);
      }
    } else {
      this.setReviewers(null);
      this.setKeepExistingReviewers(null);

      return "You must select at least one reviewer to whom to assign these charts.";
    }

    if (attrs.assignments === null) {
      return "You must assign charts to the selected reviewers";
    } else {
      try {
        attrs.assignments.forEach((model) => {
          if (!model.isValid()) {
            return model.validationError;
          }
        });
      } catch (err) {
        console.error(err.stack);
      }
    }

    if (!this.allAssigned()) {
      const total = numberFormatter(attrs.limitedTo);
      return `You must distribute ${total} charts amongst the selected reviewers.`;
    }
  },
});

export { BulkAssignForm as default };
